<template>
  <div class="quote-section">
    <div class="container">
      <div class="content-left">
        <h2 class="section-title">
          We make your custom products better and faster
        </h2>

        <p class="section-desc">
          XCL could help you with all the important and complex work of custom
          product prototyping and manufacturing, from initial designs to
          low-volume production, post-processing, logistics, and more. XCL is
          dedicated to speeding up prototyping processes and reducing costs.
        </p>
      </div>

      <div class="content-right">
        <el-form
          ref="quoteForm"
          :model="quoteForm"
          :rules="formRules"
          label-position="top"
          class="quote-form"
          data-netlify="true"
          name="quote"
          hide-required-asterisk
        >
          <el-form-item label="Name" prop="name">
            <el-input
              v-model="quoteForm.name"
              placeholder="Name"
            ></el-input>
          </el-form-item>

          <el-form-item label="Company" prop="company">
            <el-input
              v-model="quoteForm.company"
              placeholder="Company"
            ></el-input>
          </el-form-item>

          <el-form-item label="Company email" prop="companyEmail">
            <el-input
              v-model="quoteForm.companyEmail"
              placeholder="Company email"
            ></el-input>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item label="Phone" prop="phone">
                <el-input
                  v-model="quoteForm.phone"
                  placeholder="+xx xxxx"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12">
              <el-form-item label="Country" prop="country">
                <el-select
                  v-model="quoteForm.country"
                  placeholder="Select a country"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item
            label="Message(Tell Us the Quantity / Material / Surface Finish Requirements)"
            prop="message"
          >
            <el-input
              v-model="quoteForm.message"
              type="textarea"
              :rows="4"
              placeholder="Message"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="Upload 3D Design Files"
            prop="designFile"
          >
            <el-upload
              ref="uploadRef"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleFileChange"
              class="file-uploader"
            >
              <el-button type="primary">
                Select File
              </el-button>

              <span class="tip-text">
                {{ fileName || "No file chosen" }}
              </span>
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="submit-btn"
              :loading="isLoading"
              @click="submitForm"
            >
              {{ isLoading ? 'Submitting...' : 'Get Instant Quote' }}
            </el-button>
          </el-form-item>
        </el-form>

        <div class="upload-note">
          <span>🔒</span>
          <span>
            All uploads are secure and confidential. Multiple files? Please compress them into a .zip or .rar file.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { countryList } from "@/utils/countryList";

export default {
  data() {
    return {
      isLoading: false,
      quoteForm: {
        name: "",
        company: "",
        companyEmail: "",
        phone: "",
        country: "United States",
        message: "",
        designFile: null,
      },

      fileName: "",
      countryList,

      formRules: {
        name: [{ required: true, message: "Required", trigger: "blur" }],
        company: [{ required: true, message: "Required", trigger: "blur" }],
        companyEmail: [
          { required: true, message: "Required", trigger: "blur" },
          { type: "email", message: "Invalid email", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "Required", trigger: "blur" },
          { validator: this.validatePhone, trigger: "blur" },
        ],
        country: [{ required: true, message: "Required", trigger: "change" }],
        designFile: [{ required: true, message: "Required", trigger: "change" }],
      },
    };
  },

  methods: {
    validatePhone(rule, value, callback) {
      if (!value) return callback();

      const phoneReg = /^\+?[0-9\s-]{6,20}$/;

      if (phoneReg.test(value)) {
        callback();
      } else {
        callback(new Error("Please enter a valid phone number"));
      }
    },

    handleFileChange(file) {
      const allowed = [
        ".stp", ".step", ".igs", ".iges", ".stl", ".zip", ".rar"
      ];

      const ext = file.name.toLowerCase().slice(file.name.lastIndexOf("."));

      if (!allowed.includes(ext)) {
        this.$message.error("Only stp/step/igs/iges/stl/zip/rar allowed");
        this.fileName = "";
        this.quoteForm.designFile = null;
        this.$refs.uploadRef.clearFiles();
        return;
      }

      this.fileName = file.name;
      this.quoteForm.designFile = file.raw;
      this.$refs.quoteForm.validateField("designFile");
    },

    async submitForm() {
      this.$refs.quoteForm.validate(async (valid) => {
        if (!valid) return;

        this.isLoading = true;

        const formData = new FormData();
        formData.append("form-name", "quote");
        formData.append("name", this.quoteForm.name);
        formData.append("company", this.quoteForm.company);
        formData.append("companyEmail", this.quoteForm.companyEmail);
        formData.append("phone", this.quoteForm.phone);
        formData.append("country", this.quoteForm.country);
        formData.append("message", this.quoteForm.message);

        if (this.quoteForm.designFile) {
          formData.append("designFile", this.quoteForm.designFile);
        }

        if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
          console.log("✅ 本地测试表单数据：", {
            name: this.quoteForm.name,
            company: this.quoteForm.company,
            companyEmail: this.quoteForm.companyEmail,
            phone: this.quoteForm.phone,
            country: this.quoteForm.country,
            message: this.quoteForm.message,
            file: this.fileName,
          });

          this.$message.success("Local test: Submitted successfully!");
          this.resetForm();
          this.isLoading = false;
          return;
        }

        try {
          const response = await fetch("/", {
            method: "POST",
            body: formData,
          });

          if (response.ok) {
            this.$message.success("Submitted successfully!");
            this.resetForm();
          } else {
            throw new Error("Network response was not ok.");
          }
        } catch (err) {
          console.error("Submit error:", err);
          this.$message.error("Submit failed, please try again");
        } finally {
          this.isLoading = false; 
        }
      });
    },

    resetForm() {
      this.$refs.quoteForm.resetFields();
      this.fileName = "";
      this.quoteForm.designFile = null;
      this.$refs.uploadRef.clearFiles();
      this.quoteForm.country = "United States";
    },
  },
};
</script>

<style scoped>
.quote-section {
  background: #2b2f3a;
  color: #fff;
  /* ✨ 利用 clamp 实现动态内边距：最小 40px，按 8vw 缩放，最大 80px */
  padding: clamp(40px, 8vw, 80px) 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  /* ✨ 利用 clamp 实现左右两块的动态间距 */
  gap: clamp(30px, 6vw, 60px);
  align-items: center;
}

.content-left {
  flex: 1;
}

.content-right {
  flex: 1;
  width: 100%;
  background-color: #ffffff;
  /* ✨ 表单内边距自适应，手机端变窄留出空间 */
  padding: clamp(20px, 4vw, 30px);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.section-title {
  /* ✨ 标题动态字号：手机端最小 28px，大屏最大 36px */
  font-size: clamp(28px, 4vw, 36px);
  margin-bottom: 24px;
  color: #fff;
  line-height: 1.25;
}

.section-desc {
  /* ✨ 描述动态字号 */
  font-size: clamp(15px, 2vw, 16px);
  line-height: 1.8;
  color: #e0e0e0;
}

/* 表单样式 */
.quote-form >>> .el-form-item__label {
  color: #000000 !important;
  font-weight: 500;
  font-size: 15px;
  margin-bottom: -10px;
}

.quote-form >>> .el-form-item {
  margin-bottom: 6px !important;
}

.quote-form >>> .el-input__inner,
.quote-form >>> .el-textarea__inner,
.quote-form >>> .el-select .el-input__inner {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 15px;
  padding: 12px 15px;
}

.quote-form >>> .file-uploader .el-button--primary {
  background-color: #16bc9c !important;
  border-color: #16bc9c !important;
}

.quote-form >>> .file-uploader .el-button--primary:hover {
  background-color: #0e957b !important;
  border-color: #0e957b !important;
}

.quote-form >>> .el-textarea__inner {
  padding: 12px 15px;
}

.quote-form >>> .el-form-item {
  margin-bottom: 18px;
}

.submit-btn {
  width: 100%;
  height: 48px;
  background: #0e957b;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.submit-btn.is-loading {
  opacity: 0.8;
  background-color: #0e957b !important;
}

.file-uploader {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap; /* ✨ 允许文件按钮和文本在极小屏幕折行 */
}

.tip-text {
  color: #666666;
  font-size: 14px;
  margin-left: 5px;
  word-break: break-all; /* ✨ 防止用户上传的文件名过长，撑破手机屏幕 */
}

.upload-note {
  font-size: 13px;
  color: #666666;
  margin-top: 15px;
  line-height: 1.5;
  display: flex;
  gap: 8px; /* ✨ 锁头图标和文字间距 */
}

/* ✨ 响应式断点：小于 992px 时改为上下排版 */
@media (max-width: 992px) {
  .container {
    flex-direction: column;
    align-items: flex-start; /* 文字靠左对齐更利于阅读 */
  }

  .content-left {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>